import { render, staticRenderFns } from "./CommentFindingListComponent.vue?vue&type=template&id=fca2b088&"
import script from "./CommentFindingListComponent.vue?vue&type=script&lang=js&"
export * from "./CommentFindingListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports